import styled from 'styled-components';
import colors from 'constants/colors';

export const Content = styled.div`
  width: 100%;
  margin: 24px 0;
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 16px;
`;

export const ItemContainer = styled.div`
  width: calc(50% - 8px);
  display: flex;
  color: ${colors.white};
  border: 1px solid ${colors.darkGrey};
  background-color: transparent;
  padding: 16px;

  .itemTitle {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.white};

    .slider {
      margin-left: 8px;
    }
  }

  .itemValue {
    width: 100%;
  }
`;
